export default __webpack_public_path__ + "static/post-04545372619f592ed7ef96108a99409c.jpg";